import { toast } from 'react-toastify';
import localeLookup from '../config/locale';

export const showErrorNotification = (
  title = localeLookup('translations.An error occurred')
) => {
  toast.error(title, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    theme: 'colored',
  });
};
